import { render, staticRenderFns } from "./RelatedsPropertiesSection.vue?vue&type=template&id=7624ced2&scoped=true&"
import script from "./RelatedsPropertiesSection.vue?vue&type=script&lang=js&"
export * from "./RelatedsPropertiesSection.vue?vue&type=script&lang=js&"
import style0 from "./RelatedsPropertiesSection.vue?vue&type=style&index=0&id=7624ced2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7624ced2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
